/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ThumbsDownIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="thumbs-down"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M7.6 12.8L7.6 8.6L7.6 6.4C7.6 5.295 8.495 4.4 9.6 4.4L17.163 4.4C18.07 4.4 18.862 5.009 19.096 5.885L20.429 10.885C20.768 12.154 19.811 13.4 18.497 13.4L16.8 13.4C15.695 13.4 14.8 14.295 14.8 15.4L14.8 17.6C14.8 18.594 13.994 19.4 13 19.4C12.006 19.4 11.2 18.594 11.2 17.6L11.2 15.8L11.2 14.8C11.2 13.695 10.305 12.8 9.2 12.8L7.6 12.8" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8.2 12.8L7 12.8L5.4 12.8C4.295 12.8 3.4 11.905 3.4 10.8L3.4 7C3.4 5.895 4.295 5 5.4 5L5.6 5C6.705 5 7.6 5.895 7.6 7L7.6 8.6" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
